import { IBlackFriday } from '../../types/blackFriday';
import { IApplicationState } from '../../types/redux';

export function selectBlackFriday(state: IApplicationState): IBlackFriday {
  return state.blackFriday;
}
